export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8390.79a5d946.jpg";